// extracted by mini-css-extract-plugin
export default {"previewTable":"ReportComparativaPreview_previewTable__Guwux"};